import React from 'react';
import HyperLink from 'components/Core/HyperLink';
import WebsiteImage from 'components/WebsiteImage';
import { colorTypeHelper } from 'utils/colorUtility';
import { ToolCardContainer } from './styles';

const ToolCard = ({ title, description, featureImage, cardBackColor, width = '100%', href }) => {
  return (
    <ToolCardContainer
      data-testid="card-container"
      title={title}
      background={colorTypeHelper[cardBackColor]}
      width={width}
      bordered={false}
    >
      <div className="tool-card--container">
        <div className="tool-card--image-container">
          <WebsiteImage className="tool-card--image" image={featureImage} alt={title} />
        </div>
        <div className="tool-card--body-container">
          <div className="tool-card--content-container">
            <h2 className="tool-card--title" dangerouslySetInnerHTML={{ __html: title }} />
            {description && <p className="tool-card--description">{description}</p>}
          </div>
        </div>
        {href && <HyperLink data-position="Body - Card CTA" className="card--link" href={href} />}
      </div>
    </ToolCardContainer>
  );
};

export default ToolCard;
